export type RootAuthStatus = "checking" | "signedIn" | "signedOut" | "signingIn";
export type RootAuthGate = "boot" | "signIn" | "app";

export function resolveRootAuthGate(status: RootAuthStatus, hasNativeApi: boolean): RootAuthGate {
  if (status === "checking" || (status === "signedIn" && !hasNativeApi)) {
    return "boot";
  }

  if (status !== "signedIn") {
    return "signIn";
  }

  return "app";
}
